import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { h3, paragraphSmall } from '@helpers/typography';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 6px ${rgba(brand.black, 0.16)};
`;
const OverlayLink = styled.a `
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;
const ImageWrapper = styled.div `
  position: relative;
  aspect-ratio: 46 / 35;
  overflow: hidden;

  img {
    max-width: none;
    width: 100%;
    height: auto;
    ${transition('transform')};
    transform-origin: 50% 50%;

    ${Container}:hover & {
      transform: scale(1.1);
    }
  }
`;
const Content = styled.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 15px 20px 20px;
`;
const Title = styled.h2 `
  ${h3};
  color: ${brand.orange};

  a {
    color: inherit;
    text-decoration: none;

    ${Container}:hover & {
      text-decoration: underline;
    }
  }
`;
const Description = styled.p `
  ${paragraphSmall};
  margin-bottom: 0;
`;
const CardFooter = styled.div `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: auto;
  padding-top: 10px;
`;
const HighlightText = styled.span `
  ${fonts.agBook.bold};
  font-size: 16px;
  line-height: 19px;
  color: ${brand.orange};
  letter-spacing: -0.5px;
`;
const CtaList = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: auto;
`;
const Cta = styled(LinkButton) `
  &&& {
    --buttonHeight: auto;
  }
`;
export const InformationCardStyles = {
    CardFooter,
    Container,
    Content,
    Cta,
    CtaList,
    Description,
    HighlightText,
    ImageWrapper,
    OverlayLink,
    Title,
};
